import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import { Message, User } from 'lib/_types'
import { useCurrentUser } from 'store/api/yay/user'

import Avatar from 'components/Avatar/Avatar'
import ImageLoader from 'components/ImageLoader/ImageLoader'

import { REPLYABLE_TYPE, useMessageMediaInfo } from '../hooks'
import './style'

type Props = {
  message?: Message
  messageOwner?: User
  onResetReply: () => void
  onJumpToMessage: (id: number) => void
}

export const ChatReplyFormPreview = ({
  message,
  messageOwner,
  onResetReply,
  onJumpToMessage,
}: Props) => {
  if (!REPLYABLE_TYPE.includes(message?.message_type)) return null

  const { t } = useTranslation()
  const { data: currentUser } = useCurrentUser()
  const isCurrentUserMessage = currentUser?.id === message?.user_id

  const { text, thumbnailPath, iconPath, isVideo, isDeleted, shouldRender } =
    useMessageMediaInfo({
      message,
      isCurrentUserMessage,
    })

  return (
    <div
      className="ChatReplyFormPreview"
      onClick={() => {
        onJumpToMessage(message.id)
      }}
    >
      <Avatar className="ChatReplyFormPreview__avatar" user={messageOwner} />

      <div className="ChatReplyFormPreview__content">
        <div className="ChatReplyFormPreview__content__name">
          {isCurrentUserMessage
            ? t('chat.message.reply.self')
            : messageOwner
            ? t('chat.message.reply.other', { nickname: messageOwner.nickname })
            : t('chat.message.reply.deleted_user')}
        </div>

        <div
          className={cx('ChatReplyFormPreview__content__text', {
            'ChatReplyFormPreview__content__text--with_icon': iconPath,
            'ChatReplyFormPreview__content__text--deleted': isDeleted,
          })}
        >
          {iconPath && <img src={iconPath} />}
          {text}
        </div>
      </div>

      {thumbnailPath && shouldRender && (
        <div
          className={cx('ChatReplyFormPreview__thumbnail', {
            'ChatReplyFormPreview__thumbnail--video': isVideo,
          })}
        >
          <ImageLoader url={thumbnailPath} />
        </div>
      )}

      <div
        className="ChatReplyFormPreview__close"
        onClick={(e) => {
          e.stopPropagation()
          onResetReply()
        }}
      >
        <img src="/images/icon-close-gray.svg" />
      </div>
    </div>
  )
}
